module.exports = {
  "level1": {
     "name": "真实姓名",
     "idcard": "证件类型：",
     "address": "现住地址",
     "bank_number": "银行卡号",
     "wc": "确定",
     "name_nodata": "姓名不能为空",
     "id_card_nodata": "证件号码不能为空",
     "address_nodata": "地址不能为空",
     "bank_number_nodata": "银行卡号不能为空",
     "input-username":"请输入真实姓名",
     "zjhm":"证件号码",
     "input-idcard":"请输入证件号码",
     "input-address":"请输入地址",
     "zjlx":"证件类型",
     "qxzzjlx":"请选择证件类型",
     "sfz":"身份证",
     "hz":"护照",
     "jsz":"驾驶证",
     "lxz":"留学证",
     "zfbzh": "支付宝账号",
     "qsrzfbzh": "请输入支付宝账号",
     "khh": "开户行",
     "qsrkhh": "请输入开户行",
     "yhkh": "银行卡号",
     "qsryhkh": "请输入银行卡号",
     "zfzh": "支付账户",
     "qxzzfzh": "请选择支付账户",
     "gjlb": "国家列表",
     "qxzgjlb": "请选择国家/地区"
   },
  "my":{
   "bindphone":"绑定手机",
   "gqrcode":"扫下面的二维码图案或输入推广码，确认注册",
   "mqrcode":"我的二维码",
   "as":"设置",
   "pc":"初级认证",
   "ac":"高级认证",
   "smrz":"实名认证",
   "sfyz":"身份验证",
   "mm":"我的资金",
   "ms":"我要分享",
   "me":"我的收益",
   "zsr":"总收入",
   "mp": "我的推广",
   "yqhy": "邀请好友",
   "ar":"账户记录",
   "hc":"帮助中心",
   "nodata":"暂无数据",
   "med": "收益明细",
   "aes": "累计收益(USDT)",
   "one": "一代",
   "two": "二代",
   "three": "三代",
   "four": "四代",
   "ones": "一代人数",
   "twos": "二代人数",
   "threes": "三代人数",
   "fours": "四代人数",
   "promotion": "推广人数",
   "customers": "我的收益",
   "total": "合计(昨日)",
   "usdt": "USDT",
   "wdzc": "我的资产",
   "wdzc1": "我的资产",
   "wyfx": "我要分享",
   "wdsy": "我的收益",
   "wdtg": "我的推广",
   "zhjl": "账户记录",
   "fbjl": "法币记录",
   "zxkf": "联系客服",
   "wdxx": "我的消息"
  },
 "footer":{
   "home":"首页",
   "quotation":"行情",
   "currency":"币币交易",
   "lever":"合约交易",
   "assets":"资产",
   "my":"我的",
   "lc": "持币生息"
 },
 "index":{
   "wdzc":"我的资产 (USDT)",
   "xsbk":"新手必看",
   "dlhkck":"登录后可以查看",
   "dl":"登录查看",
   "zxkf":"联系客服",
   "function":"功能服务",
   "legal":"法币交易",
   "legaltxt":"用法定货币购买数字资产",
   "levertxt":"数倍于原始资金的的投资",
   "c2c":"c2c交易",
   "c2ctxt":"双向交易 套期保值",
   "increase":"涨幅榜",
   "innovate":"创新区",
   "myshop":"我的商铺",
   "order":"订单管理",
   "myc2c":"我交易的c2c",
   "usercenter":"个人中心",
   "myshare":"我的分享链接",
   "releasec2c":"发布c2c",
   "language":"语言切换",
   "security":"安全中心",
   "pay":"收款方式",
   "bindaddress":"绑定提币地址",
   "address":"提币地址",
   "aboutus":"关于我们",
   "logout":"登出",
   "vol":"24H量",
   "jc":"JC兑换BEAU",
   "kjcb": "快捷充币",
   "zcbz": "BTC、USDT..."
 },
 "transaction":{
   "buy":"买入",
   "sell":"卖出",
   "pwd":"交易密码",
   "inputpass":"输入交易密码",
   "inputnum":"输入数量",
   "limit":"限价",
   "avaiable":"可用",
   "turnover":"交易额",
   "handicap":"盘口",
   "number":"数量",
   "nonumber":"未完成数量",
   "numbered":"已完成数量",
   "price":"价格",
   "marketprice":"市价",
   "cancel":"取消",
   "total":"全站交易",
   "time":"时间",
   "nomore":"暂无更多",
   "nodata":"暂无记录",
   "getmore":"加载更多",
   "mycommission":"我的委托",
   "currentbuy":"当前委托(买入)",
   "currentsell":"当前委托(卖出)",
   "his":"历史委托(已完成)",
   "currency":"币种",
   "option":"操作",
   "wtime":"完成时间",
   "wnumber":"完成数量",
   "wprice":"完成价格"
 },
 "mk":{
   "high":"高",
   "low":"低",
   "vol":"24H量",
   "newPrice":"最新价",
   "product":"产品",
   "name":"名称",
   "rank":"涨幅榜"
 },
 "deals":{
   "issue_time":"发行时间",
   "issue_number": "发行数量",
   "white_book": "白皮书",
   "weburl": "官网",
   "video_url": "视频介绍",
   "introduction":"简介",
   "onhand":"1手等于",
   "position": "当前持仓",
   "leverorder":"杠杆下单",
   "leverposition":"杠杆持仓",
   "inputprice":"输入价格",
   "inputmul":"输入倍数",
   "selectmul":"选择倍数",
   "onehand":"1手等于",
   "hand":"交易手数",
   "marketval":"合约市值",
   "bond":"保证金",
   "service":"服务费",
   "balance":"余额",
   "type":"类型",
   "risk":"风险率",
   "total":"持仓总盈亏：",
   "onekey":"一键平仓",
   "makemore":"(做多)",
   "makeless":"(做空)",
   "current":"当前委托",
   "all":"全部",
   "weing":"委托中",
   "tding":"交易中",
   "ping":"平仓中",
   "pied":"已平仓",
   "ceiled":"已撤单",
   "weprice":"委托价",
   "oprice":"开仓价",
   "nowprice":"当前价",
   "zyprice":"止盈价",
   "zsprice":"止损价",
   "canbond":"可用保证金",
   "optime":"开仓时间",
   "pgtime":"平仓时间",
   "znum":"折合数量",
   "gprice":"隔夜费",
   "pcang":"平仓",
   "revoke":"撤单",
   "fee":"手续费",
   "you":"以当前最优价格交易"
 },
 "assets":{
   "bzxz":"币种选择",
   "copy": "复制",
   "currency":"币币",
   "lever":"合约",
   "legal":"法币",
   "curAccount":"币币账户",
   "total":"资产折合(USDT)",
   "leverAccount":"合约账户",
   "legalAccount":"法币账户",
   "avaiable":"可用",
   "lock":"冻结",
   "conversion":"折合",
   "exact":"交易账户",
   "transfer":"划转",
   "num":"数量",
   "time":"时间",
   "record":"记录",
   "caidata":"财务记录",
   "from":"从",
   "to":"到",
   "transnum":"划转数量",
   "all":"全部",
   "canuse":"可用",
   "pmin":"请输入最低划转数量",
   "cmoney":"充币",
   "tmoney":"提币",
   "caddress":"充币地址",
   "copyaddress":"复制地址",
   "a01":"请勿向上述地址充值任何非",
   "a02":"资产，",
   "a03":"否则资产将不可找回。",
   "a04":"充币仅支持simple send的方法，使用其他方法的充币暂时无法上账，请您谅解。",
   "a05":"您充值至上述地址后，需要整个网络节点的确认，1次网络确认后到账，6次网络确认可提币。",
   "a06":"最小充值金额：",
   "a07":"小于最小金额的充值将不会上账且无法退回。",
   "a08":"您的充值地址不会经常改变，可以重复充值;如有更改，我们会尽量通过网络公告或邮件通知您。",
   "a09":"请务必确认电脑及浏览器安全，防止信息被篡改或泄露。",
   "taddress":"提币地址",
   "taddressm":"请输入提币地址",
   "padd":"输入或长按粘贴地址",
   "rate":"手续费",
   "dnum":"到账数量",
   "more":"加载更多",
   "nodata":"暂无记录",
   "search":"搜索币种",
   "yczc":"隐藏为0的资产"
 },
 "td":{
   "drecord":"订单记录",
   "orecord":"已完成订单记录",
   "filter":"筛选",
   "tdtype":"交易类型",
   "buy":"购买",
   "sell":"出售",
   "wantbuy":"求购",
   "dstatus":"订单状态",
   "nofinish":"未完成",
   "finished":"已完成",
   "ceiled":"已取消",
   "payed":"已付款",
   "waitPay":"待付款",
   "reset":"重置",
   "confirm":"确定",
   "time":"时间",
   "num":"数量",
   "tdtotal":"交易总额",
   "call":"联系对方",
   "buyer":"买家",
   "seller":"卖家",
   "Sprice":"单价",
   "price":"价格",
   "ptime":"下单时间",
   "cnum":"参考号",
   "tdceil":"取消交易",
   "sureReceive":"确认已收款",
   "conPay":"付款确认",
   "ppay":"请付款",
   "paynext":"请向以下账户付款",
   "tdPrice":"交易单价",
   "tdNum":"交易数量",
   "payInfo":"付款信息",
   "accountInfo":"账号信息",
   "receiver":"收款人",
   "open":"开户行",
   "pcnum":"打款时请务必填写参考号",
   "imPay":"我已付款,点击确认",
   "tdAttion":"交易提醒",
   "odCeil":"取消订单",
   "at01":"您的汇款将直接进入卖家账户,交易过程中卖家出售的数字资产由平台托管保护。",
   "at02":"请在规定时间内完成付款，并务必点击“我已付款”，卖家确认收款后，系统会将数字资产划转到您的账户。",
   "at03":"如果买家当日取消订单达3次，将会被限制当日的买入功能。",
   "sureImpay":"请确认您已向卖家付款",
   "badClick":"恶意点击将直接冻结账户",
   "notpay":"我还没有付款给对方",
   "sureDpay":"请确认买家已向您付款",
   "sureCeil":"确认取消交易",
   "notCeil":"如果您已向卖家付款，请千万不要取消交易",
   "dover":"订单已完成，无法查看支付信息",
   "cover":"订单已取消，无法查看支付信息",
   "payFast":"付款确认后请尽快向卖家付款",
   "payClick":"如您已向卖家转账付款，请务必点击右下角“我已付款”按钮，否则有可能造成资金损失。",
   "pwait":"请等待买家付款",
   "pwd":"交易密码",
   "ppwd":"请输入交易密码",
   "sure":"确定",
   "alipay":"支付宝",
   "wechat":"微信",
   "bank":"银行卡",
   "realName":"真实姓名",
   "knum":"卡号",
   "pprice":"请输入单价",
   "pnum":"请输入数量",
   "min":"最小交易量",
   "pmin":"请输入最小交易量",
   "max":"最大交易量",
   "pmax":"请输入最大交易量",
   "buyNum":"购买数量",
   "currency":"币种",
   "pmethod":"请选择支付方式",
   "choose":"请选择",
   "mysells":"我的出售",
   "mybuys":"我的求购",
   "pcoin":"请选择货币单位"
 },
 "fat":{
   "mybuy":"我要买",
   "mysell":"我要卖",
   "ceil":"取消",
   "buy":"购买",
   "sell":"出售",
   "forsell":"出售需求",
   "forbuy":"购买需求",
   "price":"单价",
   "bprice":"按价格购买",
   "bnum":"按数量购买",
   "pbtotal":"请输入欲购买法币总额",
   "pstotal":"请输入欲出售法币总额",
   "pbnum":"请输入欲购买数量",
   "psnum":"请输入欲出售数量",
   "allbuy":"全部买入",
   "allsell":"全部卖出",
   "limit":"限额",
   "tdtotal":"交易总额",
   "autoceil":"s自动取消",
   "num":"数量",
   "submit":"下单",
   "pwd":"交易密码",
   "ppwd":"请输入交易密码",
   "sure":"确认下单",
   "reTime":"认证商家 | 注册时间 ",
   "release":"发布",
   "allOrder":"总成单",
   "dayOrder":"30日成单",
   "overOrder":"完成单",
   "rate":"完成率",
   "auPhone":"手机认证",
   "auName":"实名认证",
   "auHigh":"高级认证",
   "sellLine":"在线出售",
   "buyLine":"在线购买",
   "myshop":"我的商铺",
   "mybalance":"商家余额"
 },
 "auth":{
   "bh": "驳回",
   "bhr": "您的申请被驳回，原因如下：",
   "mycenter":"个人中心",
   "test":"身份验证",
   "gotest":"去认证",
   "testing":"审核中",
   "tested":"已认证",
   "t1":"认证后可提升提币额度",
   "t2":"认证后可进行c2c交易",
   "t3":"认证后可进行法币交易",
   "name":"姓名",
   "account":"账户",
   "number":"证件号",
   "pname":"请输入姓名",
   "pnum":"请输入证件号",
   "id_card_face": "请上传身份证正面",
   "id_card_back": "请上传身份证反面",
   "upimg":"请上传证件正反面，以及手持证件照正面照片。",
   "updata":"提交",
   "updata_again":"重新提交"
 },
 "code":{
   "mycode":"我的推广码",
   "code":"推广码",
   "qrcode":"扫上面的二维码图案或输入推广码，确认注册",
   "notice":"公告",
   "about":"相关新闻"
 },
 "safe":{
   "title":"账户安全",
   "center":"安全中心",
   "qchc":"清除缓存",
   "yysz":"语言设置",
   "ssms":"深色模式",
   "gywm":"关于我们",
   "lgpwd":"登录密码",
   "tkmm":"提币密码",
   "paypwd":"支付密码",
   "resetpwd":"修改密码",
   "paccount":"请输入手机号或邮箱",
   "next":"下一步",
   "reset":"修改",
   "stest":"安全验证",
   "ceil":"取消",
   "pcode":"请输入验证码",
   "send":"发送",
   "sure":"确认",
   "newPwd":"重新设置密码",
   "len":"密码需要6-20个字符",
   "ppwd":"请输入密码",
   "reppwd":"请再次输入密码",
   "repwd":"重置密码",
   "zpwd":"交易密码"
 },
 "met":{
   "add":"添加方式",
   "open":"开户行名称",
   "bank":"银行账号",
   "realname":"真实姓名",
   "alipay":"支付宝账号",
   "wename":"微信昵称",
   "wechat":"微信账号",
   "save":"保存",
   "popen":"请输入开户行名称",
   "pbank":"请输入开户行账号",
   "pname":"请输入真实姓名",
   "palipay":"请输入支付宝账号",
   "pwename":"请输入微信昵称",
   "pweaccount":"请输入微信账号"
 },
 "ads":{
   "tas":"提币地址",
   "address":"地址",
   "noads":"您还没有地址",
   "adds":"地址",
   "padd":"提币或粘贴地址",
   "remark":"备注",
   "cel":"删除"
 },
 "call":{
   "callme":"联系我们",
   "Privacy":"隐私政策"
 },
 "jc":{
   "title":"JC积分兑换BEAU平台",
   "bind":"绑定账号",
   "balance":"JC余额",
   "cannum":"可用JC数量:",
   "new":"BEAU最新价:",
   "exnum":"兑换数量:",
   "pnum":"请输入JC数量",
   "canex":"可兑换BEAU数量:≈",
   "exnow":"立即兑换",
   "record":"兑换记录",
   "exprice":"兑换价格:",
   "extime":"兑换时间",
   "not":"可用积分数量不足",
   "usenum":"使用JC数量",
   "paccount":"请输入账号",
   "ppwd":"请输入密码",
   "gotd":"去交易"
 },
 "lg":{
   "welcome":"您好！欢迎登录",
   "hsa": "已有账号?",
   "lgs":"登录",
   "lgbt":"登录",
   "lgtel":"手机登陆",
   "lgeml":"邮箱登陆",
   "paccount":"手机号或邮箱",
   "ppwd":"请输入密码",
   "ppwd2":"请确认密码",
   "pcode":"请输入验证码",
   "qsryqm": "请输入邀请码",
   "mepwd":"记住密码",
   "noaccount":"还没有账号？",
   "qregister":"去注册",
   "register":"注册",
   "phregister":"手机注册",
   "emregister":"邮箱注册",
   "noset":"注册后不能修改",
   "pphone":"请输入手机号",
   "next":"下一步",
   "have":"已有账号？",
   "ceil":"取消",
   "msgtest":"短信验证",
   "send":"获取验证码",
   "sure":"确定",
   "email":"请输入邮箱地址",
   "emtest":"邮箱验证",
   "scode":"发送验证码",
   "pemcode":"请输入验证码",
   "ppcode":"请输入手机验证码",
   "ftpwd":"忘记密码？",
   "ftpwds":"忘记密码",
   "ptext":"请输入手机号或邮箱",
   "safetest":"安全验证",
   "sjh":"手机号",
   "yzm":"验证码",
   "mm":"密码",
   "qrmm":"确认密码",
   "mmcd":"密码长度8-12位",
   "language":"语言切换",
   "kjzc": "联系客服快速注册",
   "kjzc1": "无法接收验证码？",
   "kjzc2": "快捷注册",
   "wyzx": "我已知晓",
   "qtxyxzh": "提示：请填写有效的电子邮件地址或手机号，可用于找回密码"
 },
 "gjrz":{
   "title":"高级认证",
   "t1":"1、支持小于8M的JPG、JPEG或PNG格式图片。",
   "t2":"2、证件照要求清晰，不允许任何修改和遮挡，必须看清人像，证件号和姓名。",
   "t3":"3、照片需免冠，建议未化妆，手持证件人的五官清晰可鉴，完整需露出手臂。",
   "t4":"确定",
   "bh":"驳回",
   "shz":"审核中",
   "shtg":"审核通过",
   "nyrzcg":"您已认证成功",
   "sczjz":"上传证件照",
   "sczjzmz": "上传证件正面照",
   "sczjbmz": "上传证件背面照",
   "scgrqmz": "上传手持证件照"
 },
 "chongzhi":{
   "title":"充币",
   "cbjl": "充币记录",
   "t1":"数量",
   "t2":"请输入数量",
   "t3":"凭证描述(选填)",
   "t4":"请输入描述",
   "t5":"凭证图片",
   "t6":"确定",
   "t7":"链名称",
   "t8":"二维码",
   "t9":"保存二维码",
   "t10":"充币地址",
   "t11":"复制",
   "zy": "注意",
   "tips1": "请勿向上述地址充值任何非本币种资产否则资产不可找回",
   "tips2": "1.钱包/平台的兼容：即对该网络支持；如目标平台不支持您的提币网络，将导致资产无法找回。",
   "tips3": "2.您充值网络和目标平台是一致的；如您选择了目标地址是以太坊网络，但充值选择了TRC20智能链，您或将无法找回您的数字资产。",
   "tips4": "3.充值前确保您的地址、金额正确。",
   "tips5": "温馨提示：由于区块网络匿名和私密，一旦输入错误信息，您将损失对应资产。请务必仔细核对您的充值地址及数量"
 },
 "tibi":{
   "title":"提币",
   "tbjl":"提币记录",
   "t1":"提币地址",
   "t2":"请输入提币地址",
   "t3":"提币数量",
   "qsrtbsl":"请输入提币数量",
   "t4":"最低提币",
   "t5":"交易密码",
   "t6":"请输入交易密码",
   "t7":"手续费",
   "t8":"到账数量",
   "t9":"确定",
   "sc":"删除",
   "bj":"编辑",
   "bq": "标签(Memo)",
   "qsrbq":"请输入标签",
   "yhktx":"银行汇款",
   "yhmc": "银行名称",
   "qsryhmc": "请输入银行名称",
   "yhzh": "银行账号",
   "qsryhzh":"请输入银行账号",
   "gjhkdm": "国际汇款代码",
   "qsrgjhkdm":"请输入国际汇款代码",
   "yhdz": "银行地址",
   "qsryhdz":"请输入银行地址",
   "skrxm": "收款人姓名",
   "qsrskrxm":"请输入收款人姓名",
   "skrdh": "收款人电话",
   "qsrskrdh":"请输入收款人电话",
   "skrdz": "收款人地址",
   "qsrskrdz":"请输入收款人地址"
 },
 "huazhuan":{
   "title":"USDT划转",
   "t1":"币币账户余额",
   "t2":"合约账户余额",
   "t3":"划转数量",
   "t4":"请输入数量",
   "t5":"划转方向",
   "t6":"从",
   "t7":"币币账户",
   "t8":"至",
   "t9":"合约账户",
   "t10":"确定",
   "zf": "支付",
   "ky": "可用",
   "dd": "得到",
   "qbdh": "全部兑换",
 },
 "banner":{
   "title": "详情"
 },
 "download":{
   "t1": "移动交易，随时随地",
   "xz": "下载"
 },
 "xgdlmm":{
   "title": "修改登录密码",
   "zh":"账号",
   "zhts":"手机号或邮箱",
   "yzm":"验证码",
   "yzmts":"请输入验证码",
   "hqyzm":"获取验证码",
   "mm":"密码",
   "mmts":"密码长度6-12位",
   "qrmm":"确认密码",
   "send":"发送",
   "qr":"确认"
 },
 "sztkmm":{
   "title":"设置交易密码",
   "dlmm":"登录密码",
   "dlmmts":"请输入登录密码",
   "xmm":"新密码",
   "mmts":"密码长度6位数字",
   "qrmm":"确认密码",
   "qr":"确认",
   "qd": "确定",
   "sztkts": "提示：请到安全中心设置交易密码"
 },
 "rule":{
   "title":"活动规则",
   "title2":"规则",
   "title3":"活动"
 },
 "news":{
   "title":"我的消息",
   "ckxq":"查看详情",
   "gg":"公告"
 },
 "xsbk":{
   "title":"新手必看"
 },
 "search":{
   "qx":"取消",
   "rmss":"热门搜索",
   "ss": "搜索"
 },
 "wdtg":{
   "title": "好友齐欢聚",
   "yq": "邀请",
   "zyj": "赚佣金",
   "wdyqlj":"我的邀请链接",
   "wdyqm":"我的邀请码",
   "schbyq":"生成海报邀请",
   "ljtgsy":"累计推广收益",
   "ljkh":"累计客户(人)",
   "tkrs":"邀请人数",
   "ljyj":"累计佣金",
   "yjmx":"佣金明细",
   "ljyjjl":"累计佣金奖励(usdt)",
   "ljsy":"累计收益",
   "ljyqjl":"累计邀请奖励(usdt)",
   "fxd":"分享到",
   "wxhy":"微信好友",
   "wxpyq":"微信朋友圈",
   "bctp":"保存图片",
   "qx":"取消",
   "t1": "边挖矿 边抄币",
   "t2": "盈利全归你",
   "t3": "长按图片识别或扫一扫"
 },
 "bzhl":{
   "title":"AI赚币",
   "gz":"规则",
   "tgdd":"托管订单",
   "zztgdzj":"正在托管的资金",
   "yjjrsy":"预估日收益",
   "ljsy":"累计收益",
   "tgzdd":"托管中订单",
   "cljxcp":"策略竞选产品",
   "dbxe":"单笔限额",
   "rsyl":"日收益率",
   "zq":"周期",
   "qmr":"立即购买",
   "bbzhzc": "账户资产",
   "zcc": "总持仓(USDT)",
   "dd":"订单",
   "buy":"买入",
   "jxcp":"精选产品",
   "ckdd":"查看订单",
   "gd":"更多",
   "xzbzts": "简单，安全。可选择多种币种进行派息",
   "qtbz": "其它币种"
 },
 "bzhlgm":{
   "title":"搬砖获利",
   "bzhld":"搬砖获利得usdt",
   "qtzq":"USDT7天周期",
   "rsyl":"日收益率(%)",
   "lczq":"理财周期",
   "dbxe":"单笔限额",
   "pxsj":"派息时间",
   "mr":"每日",
   "dqfh":"到期返还",
   "tgzj":"托管资金",
   "tqsh":"提取赎回",
   "yjsy":"预计收益(USDT)",
   "kyzc":"可用资产(USDT)",
   "cpjs":"产品介绍",
   "tgje":"托管金额",
   "qsrtgje":"请输入托管金额",
   "qb":"全部",
   "rm":"立即购买",
   "cpzq":"产品周期",
   "jxr":"计息日",
   "jiexr":"结息日",
   "yjdzr":"预计到账日",
   "gz":"了解规则以及权益"
 },
 "bzhlwdtg":{
   "title":"订单状态",
   "tgz":"托管中",
   "ywc":"已完成",
   "ysh":"已赎回",
   "tgje":"托管金额/周期天数",
   "rsyl":"日收益率",
   "yhl":"已获利/剩余天数",
   "xdsj":"下单时间",
   "sh":"赎回",
   "ddxq":"订单详情",
   "ddh":"订单号"
 },
 "bzjj":{
   "t1": "天天赚不停",
   "t2": "搬砖是通过将USDT托管给平台，由平台的专业团队进行搬砖权利，参与者在资金托管期间可获得平台的搬砖收入分成",
   "cpld": "产品亮点",
   "scsq": "随存随取",
   "pxzq": "派息周期",
   "mtxf": "每天下发",
   "hqlx": "活期利息",
   "zj": "100%资金",
   "aqbz" :"安全保障",
   "jjrsy": "节假日收益",
   "sybjd":"收益不间断",
   "bjd": "不间断",
   "cgcrh": "成功存入后",
   "dtqx": "当天起息",
   "jglz": "举个例子",
   "syjs": "收益计算",
   "cont1": "会员在平台存入了10000U，选择了周期为七天，日收益率为0.3%~0.5%的理财产品，则每天的收益如下：",
   "cont2": "最低：10000U× 0.3%-30U",
   "cont3": "最高：10000U× 0.5%-50U",
   "cont4": "既：7天后可以获得210U-350U的收益，收益每日下发，下发的收益可随时存取，存入的本金，到期满后，自动返回自您的钱包账户。",
   "gywyj": "关于违约金",
   "cont5": "若您希望转出未到期的本金，则会产生违约金，违约金=违约结算比例*剩余天数*投资数量。",
   "cont6": "举例：该产品的违约结算比例为0.4%，剩余3天到期，投资数量为1000，则违约金=0.4%*3*1000=12U，实际退还本金为1000U-12U=988U",
   "wycy": "我要参与"
 },
 "zyzs":{
   "title":"止盈止损",
   "zy":"止盈",
   "zs":"止损",
   "qsrzyjg":"请输入止盈价格",
   "qsrzsjg":"请输入止损价格",
   "cfjglx":"触发价格类型：",
   "zsjg":"指数价格",
   "scjg":"市场价格",
   "pcfs":"平仓方式：",
   "kpcw":"可平仓位",
   "qbcw":"全部仓位",
   "wxts":"温馨提示：",
   "cont": "市场平仓，可能会因为行情波动剧烈等问题导致一定概率市价单下单失败，无法成功止盈止损。",
   "qr":"确认"
 },
 "bbjy":{
   "mr":"买入",
   "mc":"卖出",
   "mai":"买",
   "sell":"卖",
   "xj":"限价",
   "sj":"市价",
   "pk":"盘口",
   "jg":"价格",
   "sl":"数量",
   "mrl":"买入量",
   "ss":"数量",
   "mcl":"卖出量",
   "ky":"可用",
   "km":"可买",
   "ksell":"可卖",
   "jye":"交易额",
   "dqwt":"当前委托",
   "lswt":"历史委托",
   "jj":"简介",
   "wtzl":"委托总量",
   "wtjg":"委托价格",
   "ycjl":"已成交量",
   "cjjj":"成交均价",
   "cd":"撤单",
   "xd":"下单",
   "ywc":"已完成",
   "ycd":"已撤单",
   "wqcj":"完全成交",
   "zx":"自选",
   "scjg":"市场价格",
   "fhsj":"发行时间",
   "fhsl":"发行数量",
   "bps":"白皮书",
   "gw":"官网",
   "qx":"取消"
 },
 "hyjy":{
   "mai":"买",
   "sell":"卖",
   "kc":"开仓",
   "pc":"平仓",
   "cc":"持仓",
   "kp":"可平",
   "kpc":"可平空",
   "kcc":"可持仓",
   "kkd":"可开多",
   "kpd":"可平多",
   "kkk":"可开空",
   "xj":"限价",
   "sj":"市价",
   "xjwt":"限价委托",
   "sjwt":"市价委托",
   "pk":"盘口",
   "jg":"价格",
   "sl":"数量",
   "gg":"杠杆",
   "tzgg":"调整杠杆",
   "ggbs": "杠杆倍数",
   "mrl":"买入量",
   "ky":"可用",
   "jye":"交易额",
   "dqwt":"当前委托",
   "lswt":"历史委托",
   "ptwt":"普通委托",
   "dqwtmr":"当前委托(买入)",
   "dqwtmc":"当前委托(卖出)",
   "hywt":"合约委托",
   "jj":"简介",
   "wtzl":"委托总量",
   "wtjg":"委托价格",
   "ycjl":"已成交量",
   "cjjj":"成交均价",
   "cd":"撤单",
   "xd":"下单",
   "qbcd":"全部撤单",
   "wqcj":"完全成交",
   "ywc":"已完成",
   "ycd":"已撤单",
   "zx":"自选",
   "scjg":"市场价格",
   "fhsj":"发行时间",
   "fhsl":"发行数量",
   "bps":"白皮书",
   "gw":"官网",
   "mrzd":"买入做多",
   "mrpk":"买入平空",
   "mczk":"卖出做空",
   "mcpd":"卖出平多",
   "mrkdkz":"买入开多(看涨)",
   "mrpkkz":"买入平空(看涨)",
   "mckkkd":"卖出开空(看跌)",
   "mcpdkd":"卖出平多(看跌)",
   "yxhy":"永续合约",
   "dc":"多仓",
   "kcjj":"开仓均价(BUSDT)",
   "wsxyl":"未实现盈利(BUSDT)",
   "ygqpj":"预估强评价(BUSDT)",
   "syl":"收益率",
   "cwbzj":"仓位保证金(BUSDT)",
   "cw":"仓位(张)",
   "cwjz":"仓位价值(BUSDT)",
   "bzjl":"保证金率",
   "kpz":"可平(张)",
   "bdzs":"标的指数",
   "tzbzj":"调整保证金",
   "zyzs":"止盈止损",
   "zjbzj":"增加保证金",
   "jsbzj":"减少保证金",
   "tyhy":"体验合约",
   "ccz":"持仓(张)",
   "cwbzjt":"仓位保证金(TBTC)",
   "zdzjbzj":"最多增加保证金(TBTC)",
   "zjbzjt":"增加保证金(TBTC)",
   "zhang":"数量",
   "qblx":"全部类型",
   "qb":"全部",
   "ccjg":"持仓价格",
   "ccsl":"持仓数量",
   "yk":"盈亏",
   "ccsj":"持仓时间",
   "zy":"止盈",
   "zs":"止损",
   "zje":"总金额",
   "kcs":"开仓数",
   "kcjg":"开仓价格",
   "ss":"手数",
   "hand":"1手 =",
   "qx":"取消",
   "qr":"确认"
 },
 "kxt":{
   "gao":"高",
   "di":"低",
   "wtgd":"委托挂单",
   "cj":"成交",
   "jj":"简介",
   "sj":"时间",
   "fx":"方向",
   "jg":"价格",
   "sl":"数量",
   "mr":"买入",
   "mc":"卖出",
   "mp":"买盘",
   "sp":"卖盘",
   "slb":"数量",
   "fhsj":"发行时间",
   "fhsl":"发行数量",
   "bps":"白皮书",
   "gw":"官网",
   "fz":"min",
   "xs":"hour",
   "tian":"day",
   "zhou":"week",
   "yue":"month",
   "gd":"More",
   "ft":"副图",
   "zt":"主图",
   "sdt":"深度图",
   "zx":"自选",
   "djck": "点击查看"
 },
 "zhjl":{
   "cbtb":"充币提币",
   "jymx":"交易明细",
   "tgyj":"推广佣金",
   "wwc": "未完成",
   "ywc": "已完成"
 },
 "zwsj":{
   "title":"暂无数据"
 },
 "bzxz":{
   "title":"选择币种"
 },
 "jghy":{
   "jghy": "期货合约",
   "yxhy": "永续合约",
   "mz": "买涨",
   "md": "买跌",
   "gmj": "购买价",
   "jsj": "结算价",
   "xj": "现价",
   "fx": "方向",
   "sl": "数量",
   "jgsj": "交割时间",
   "gb": "关闭",
   "jxxd": "继续下单",
   "cclb": "持仓列表",
   "zc": "在持",
   "lscc": "历史持仓",
   "qblx": "全部类型",
   "yk": "盈亏",
   "ddqr": "订单确认",
   "dqsj": "到期时间",
   "jssj": "结算时间",
   "sy": "收益",
   "tzje": "投资金额",
   "zdje": "投资金额大于0",
   "kyye": "可用余额：",
   "kyye2": "可用余额",
   "sxf": "手续费：",
   "sxfl": "手续费",
   "jypz": "名称",
   "jyfx": "交易方向",
   "qrxd": "确认下单",
   "fs": "more",
   "dqye": "当前余额"
 },
 "kjmb":{
   "title":"快捷买币",
   "gm": "购买USDT",
   "wxts": "温馨提示：",
   "wxts-copy": "请复制USDT地址，您需要使用该地址购买USDT。",
   "copy": "复制",
   "ljmb": "立即买币",
   "buy": "购买",
   "cs": "出售",
   "qx": "取消",
   "gmsl": "购买数量",
   "cssl": "出售数量",
   "qsrgmsl": "请输入购买数量",
   "qsrcssl": "请输入出售数量",
   "qxzzffs": "请选择支付方式",
   "yhk": "银行卡",
   "wx": "微信",
   "zfb": "支付宝",
   "jg": "价格",
   "kyye": "可用余额：",
   "zxjysl": "最小交易数量：",
   "ts1": "1.买卖商家均为平台认证商家，提供24小时服务。",
   "ts2": "2.如订单产生纠纷，请立即联系客服进行处理。",
   "fzcg": "复制成功"
 },
 "tips":{
   "jymm": "交易密码",
   "szjymm": "设置交易密码",
   "qsrjymm": "请输入交易密码",
   "jymmts": "请到安全中心设置交易密码"
 },
 "xyf":{
   "title": "信用分",
   "pgsj": "评估时间"
 },
 "dzrz":{
   "title": "地址认证",
   "sdddz":"水电单地址",
   "tips":"您需要填写地址信息和提交水电费或者宽带地址的账单",
   "tpsc": "账单图片上传",
   "ts": "提示：您需要填写地址信息和提交水电费或者宽带地址的账单",
   "qsczdtp":"请上传账单图片"
 },
  "newReg":{
   "sjh": "手机号",
   "yx": "邮箱",
   "yqm": "邀请码",
   "yqm2": "邀请码（可选）",
   "cjzh": "创建账户",
   "sysjhzyx": "使用手机号/电子邮箱注册",
   "sj": "手机",
   "yhxy": "《用户协议》",
   "yhxy2": "我已阅读并同意《用户协议》"
 },
 "mbwt":{
   "title": "密保问题设置",
   "mbwt": "密保问题",
   "qtxda": "请填写答案",
   "qsrxmm": "请输入新密码",
   "sydqmmcz": "使用当前密码重置",
   "zhmm": "密保问题找回密码",
   "ysz": "已设置",
   "tg": "跳过",
   "tj": "提交",
   "zyts": "重要提示：",
   "zytsCont": "请勿泄露密保答案和验证码，并牢记密保问题，这将有助于您找回密码"
 },
 "xbsg":{
   "title": "新币专区",
   "wdsg": "我的申购",
   "scts": "锁仓天数：",
   "sy": "剩余",
   "ljsg": "立即申购",
   "ysk": "已售空",
   "xzjdy": "现在就订阅",
   "dy": "订阅",
   "fxjg": "发行价格",
   "fxl": "发行量",
   "ssrq": "上市日期",
   "yxqx": "有效期限",
   "qsrsl": "请输入数量",
   "syl": "剩余量",
   "sgrq": "申购日期",
   "sgsl": "申购数量",
   "bz": "币种",
   "yebz": "USDT余额不足",
   "tgsl": "通过数量",
   "shz": "审核中",
   "wtg": "未通过",
   "ytg": "已通过"
 },
 "wydb":{
   "title": "我要贷币",
   "db": "贷币",
   "dbz": "贷币中",
   "jl": "记录",
   "jdzq": "借贷周期(天)",
   "qhk": "去还款",
   "ljdb": "累计贷币(usdt)",
   "dhkbs" :"待还款笔数",
   "jkje": "借款金额(usdt)",
   "qsrje": "请输入金额",
   "rll": "日利率",
   "hkfs": "还款方式",
   "dqych": "到期一次还本息",
   "lx": "利息",
   "fkjg": "放款机构",
   "tpsc": "信用贷款(图片上传)",
   "fwxx": "房屋信息",
   "srzm": "收入证明(雇佣关系)",
   "yhmx": "银行明细",
   "zjz": "证件照",
   "yd": "本人已阅读并同意",
   "xy": "申请贷币协议",
   "sqdb": "点击申请贷币",
   "gb": "关闭",
   "qd": "确定",
   "ts": "请勾选申请贷币协议",
   "dbjl": "贷币记录",
   "hkhth": "贷款合同号",
   "wsh": "未审核",
   "yfk": "已放款",
   "sqrq": "申请日期",
   "zq": "周期",
   "dbsl": "贷币数量",
   "zhke": "总还款额",
   "yhkxq": "应还款详情",
   "bqyhk": "本期应还款（USDT）",
   "hktips": "请确保余额充足，余额不足请先充值再还款",
   "bj": "本金",
   "jie": "借",
   "ljhk": "立即还款",
   "qcz": "去充值",
   "yebzqxcz": "余额不足，请先充值再还款",
   "znj": "滞纳金",
   "yqts": "逾期天数"
 },
 "hkxq":{
   "dd":"订单",
   "fzhkdz":"复制还款地址",
   "hkxq": "还款详情",
   "zlx": "总利息",
   "zhk": "总还款",
   "hkjg": "还款机构",
   "qschkpz": "请上传还款凭证",
   "hkpz": "还款凭证"
 },
 "bbjyNew":{
   "jylx": "交易类型",
   "jyze": "交易总额"
 },
 "indexNew":{
   "title": "添加Spmaxex到主界面",
   "t1": "快速存取 全屏幕体验",
   "t2": "点击下方工具栏上的",
   "t3": "并选择",
   "t4": "添加到主屏幕",
   "t5": "添加到桌面体验完整版Spmaxex",
   "t6": "添加到个人收藏",
   "t7": "在页面上查找"
 },
 "bind":{
   "title": "邮箱认证",
   "ybd": "已绑定",
   "wbd": "未绑定",
   "yrz": "已认证",
   "wrz": "未认证",
   "ts": "为保护您的账户，建议绑定邮箱",
   "qsryxdz": "请输入邮箱地址"
 },
 "status":{
    "statusText": ['失败','等待处理','成功'],
 },
 "tipsNew":{
   "wjmmts": "通过验证码找回密码",
   "qscpztp": "请上传凭证图片",
   "emailgsts": "输入的邮箱不符合规则",
   "telgsts": "输入的手机号码格式有误",
   "lcmmbyz": "两次密码输入不一致",
   "zdsl": "最低数量 ",
   "sldydy": "数量大于等于",
   "zxtzsl": "最低数量 ",
   "ddz": "等待中",
   "xs": "小时",
   "min": "最小数量 ",
   "max": "最大数量 ",
   "yebz": "余额不足",
   "qsrss": "请输入手数",
   "zdss": "最低手数",
   "yjj": "已拒绝",
   "shz": "赎回中",
   "zwkfcz": "该币种暂未开放充值",
   "jiaoge": "交割",
   "zhang": "涨",
   "die": "跌",
   "cjxnzh": "创建虚拟账户"
 },
 "langNew2":{
   "flzq": "福利专区",
   "qdjl": "签到奖励",
   "mrqdjl": "每日签到奖励",
   "qd": "签到",
   "yqd": "已签到",
   "hdgz": "活动规则",
   "qdjl2": "签到记录",
   "qdcg": "签到成功",
   "yhd": "已获得",
   "lq": "领取",
   "dyt": "第一天",
   "det": "第二天",
   "dst": "第三天",
   "dsit": "第四天",
   "dwt": "第五天",
   "dlt": "第六天",
   "dqt": "第七天",
   "jxz": "进行中"
 },
 "langNew":{
  "kp": "开盘",
  "zuoshou": "昨收",
  "zg": "最高",
  "zd": "最低",
  "dqjg": "当前价格",
  "pcjg": "平仓价格",
  "gd": "挂单",
  "gdj": "挂单价",
  "gdjg": "挂单价格",
  "xfbzj": "需付保证金：",
  "ksrfw": "可输入范围：",
  "shou": "手",
  "fdjyk": "浮动净盈亏",
  "pcsl": "平仓数量",
  "cx": "撤销",
  "qrpc": "确认平仓",
  "sx": "筛选",
  "cz": "重置",
  "zdl": "知道了",
  "kccg": "开仓成功！",
  "xzfx": "选择方向",
  "lx": "类型",
  "xgcc": "修改持仓",
  "szzyzs": "设置止盈止损",
  "szhb": "加密货币",
  "gjs": "贵金属",
  "yy": "原油",
  "jy": "交易",
  "jmhb": "加密货币",
  "gdsj": "挂单时间",
  "gdsl": "挂单数量",
  "fs": "time",
  "qbdl": "钱包登录",
  "qbdlts": "请用钱包浏览器访问登录",
  "tcmnzh": "退出虚拟账户",
  "bc": "补仓",
  "qdlzszh":"请登录真实账户充值",
  "ts": "提示",
  "czsqytj": "充值申请已提交",
  "czdzts": "充值申请已提交，如果充值未到账？",
  "fhsy": "返回首页",
  "je": "金额",
  "zdje": "最低金额 ",
  "zdje2": "最大金额 "
 }
}



// WEBPACK FOOTER //
// ./src/utils/lang/zh.js